import SignUpWriter from "../components/writer/CreateAccount";
import WriterDashboardLayout from "../components/WriterDashboardLayout";
function WriterCreateAccountPage(){
    return(
        
            <SignUpWriter/>
        
    )
}
export default WriterCreateAccountPage